// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"25":"ec3be031","286":"53bb3c0b","378":"abf101dc"}[chunkId] + ".js";
};